import axios from "axios";
import queryString from "query-string";
import ProgressBar from "./ProgressBar";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import base_url from "./../../../api/bootapi";
import Tooltip from "react-bootstrap/Tooltip";
import { useLocation } from "react-router-dom";
import PlanModal from "../../../Modal/PlanModal";
import React, { useState, useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import PlanModalOBD from "../../../Modal/PlanModalOBD";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useStateValue } from "../ContextAPI/StateProvider";

const ActivationTypeForm = () => {
  // Taking CustomerId from url if present
  const { search } = useLocation();
  const queryparam = queryString.parse(search);

  const { addToast } = useToasts();
  const [
    { servicePlan, backupCustomerInformation, servicePlanGPS, servicerules },
    dispatch,
  ] = useStateValue();

  const [stateCust, setstateCust] = useState(
    JSON.parse(sessionStorage.getItem("activationType"))
  );
  const [imeisameerror, setimeisameerror] = useState(false);
  const history = useHistory();
  let canceltoken;
  const [newline, setnewline] = useState(
    JSON.parse(sessionStorage.getItem("activationType"))?.devices || []
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: JSON.parse(sessionStorage.getItem("activationType")),
  });

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (!JSON.parse(sessionStorage.getItem("movetoactivationpage"))) {
      history.push("/registration/customer-information");
      addToast(
        "Error! You cannot proceed furthur before filling previous details",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }, []);
  const inputEvent = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setstateCust((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleimeichange = (e, i) => {
    var lines = [...newline];
    lines[i].imei = e.target.value;
    if (Number(e.target.value) && e.target.value.toString().length > 15) {
      lines[i].error = true;
      lines[i].errormessage = "IMEI number limit exceeds";
      lines[i].category = "";
      lines[i].servicePlan = "";
    } else {
      if (Number(e.target.value)) {
        if (typeof canceltoken !== typeof undefined) {
          canceltoken.cancel("Cancelling previous request");
        }
        canceltoken = axios.CancelToken.source();

        axios
          .get(`${base_url}/info/imei_validation/${e.target.value}`, {
            cancelToken: canceltoken.token,
          })
          .then((res) => {
            if (res.data.message === "Valid IMEI") {
              let lines2 = [...newline];
              lines2[i].device_model = res.data.details.model;
              lines2[i].error = false;
              lines2[i].category = res.data.details.category;
              setnewline(lines2);
            } else {
              let lines2 = [...newline];
              lines2[i].error = true;
              lines2[i].errormessage = res.data.message;
              lines2[i].device_model = "";
              lines2[i].category = "";
              lines2[i].servicePlan = "";
              lines2[i].price = "";
              lines2[i].plan_name = "";
              lines2[i].plantype = "plus_quarterly";
              lines2[i].plantypeobd = "plus_obd_quarterly";
              setnewline(lines2);
            }
          })
          .catch((err) => {
            let lines2 = [...newline];
            lines2[i].error = true;
            lines2[i].device_model = "";
            lines2[i].errormessage = err?.response?.data?.message;
            lines2[i].category = "";
            lines2[i].servicePlan = "";
            lines2[i].price = "";
            lines2[i].plan_name = "";
            lines2[i].plantype = "plus_quarterly";
            lines2[i].plantypeobd = "plus_obd_quarterly";
            setnewline(lines2);
          });
      } else {
        lines[i].error = true;
        lines[i].errormessage = "Invalid IMEI Number";
        lines[i].category = "";
        lines[i].servicePlan = "";
        lines[i].price = "";
        lines[i].plan_name = "";
        lines[i].plantype = "plus_quarterly";
        lines[i].plantypeobd = "plus_obd_quarterly";
      }
    }

    setnewline(lines);
  };
  const handledevicenamechange = (e, i) => {
    var lines = [...newline];
    lines[i].device_name = e.target.value;
    if (
      lines[i].error === true &&
      lines[i].errormessage === "Device Name is required"
    ) {
      lines[i].error = false;
      lines[i].errormessage = "";
    }
    setnewline(lines);
  };
  const handledeviceplanchange = (e, i, cat = "gps") => {
    var lines = [...newline];
    if (cat === "obd") {
      // lines[i].servicePlan = e.target.value;
      lines[i].servicePlan = servicePlan[e.target.value]["service_plan_id"];
      lines[i].plantypeobd = e.target.value;
      lines[i].price = servicePlan[e.target.value]["price"];
      lines[i].plan_name = servicePlan[e.target.value]["service_plan_name"];
    } else {
      lines[i].price = servicePlanGPS[e.target.value]["price"];
      lines[i].plan_name = servicePlanGPS[e.target.value]["service_plan_name"];
      lines[i].servicePlan = servicePlanGPS[e.target.value]["service_plan_id"];
      lines[i].plantype = e.target.value;
    }
    if (
      lines[i].error === true &&
      lines[i].errormessage === "Service Plan is required"
    ) {
      lines[i].error = false;
      lines[i].errormessage = "";
    }
    setnewline(lines);
  };
  const canceldevice = (index) => {
    var lines = [...newline];
    lines.splice(index, 1);
    setnewline(lines);
  };

  const submitcustomerinformation = (data2) => {
    setimeisameerror(false);
    for (let i = 0; i < newline.length; i++) {
      if (newline[i].error) {
        return;
      } else if (newline[i].imei === "") {
        newline[i].error = true;
        newline[i].errormessage = "IMEI is required";
        return false;
      } else if (newline[i].device_name === "") {
        newline[i].error = true;
        newline[i].errormessage = "Device Name is required";
        return false;
      } else if (newline[i].servicePlan === "") {
        newline[i].error = true;
        newline[i].errormessage = "Service Plan is required";
        return false;
      }
    }
    function checkForDuplicates(array, keyName) {
      return new Set(array.map((item) => item[keyName])).size !== array.length;
    }
    if (checkForDuplicates(newline, "imei")) {
      setimeisameerror(true);
      return;
    }
    stateCust.devices = newline;
    sessionStorage.setItem("activationType", JSON.stringify(stateCust));
    sessionStorage.setItem("movetopaymentpage", true);
    dispatch({
      type: "ADD_TO_ACTIVATIONTYPE",
      activationType: stateCust,
    });
    dispatch({
      type: "ADD_TO_MOVETOPAYMENT",
      movetopaymentpage: true,
    });
    history.push("/registration/payment-method");
  };
  const handlepreviousbutton = () => {
    if (JSON.parse(sessionStorage.getItem("userexists")) === true) {
      dispatch({
        type: "ADD_TO_CUSTOMERINFORMATION",
        customerInformation: backupCustomerInformation,
      });
      sessionStorage.setItem(
        "customerInformation",
        JSON.stringify(backupCustomerInformation)
      );
      sessionStorage.setItem("userexists", false);
      sessionStorage.setItem("movetoactivationpage", false);
      dispatch({
        type: "ADD_TO_USEREXIST",
        userexists: false,
      });
    }
    dispatch({
      type: "ADD_TO_MOVETOACTIVATION",
      movetoactivationpage: false,
    });
    history.push("/registration/customer-information");
  };

  //----------------------->Showing Image in Toolpit<-----------------------------

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <img
        alt="where to find imei"
        src="./findimei.jpg"
        width={175}
        height={175}
      />
    </Tooltip>
  );
  const movetoreactivate = () => {
    window.open(
      `https://amcrestgps.net/gps-activation/#/reactivation?customer_id=${queryparam["customer_id"]}`
    );
  };
  return (
    <form id="myForm" onSubmit={handleSubmit(submitcustomerinformation)}>
      <div>
        <ProgressBar typeofactive="Activation" />
        <div>
          <div className="form-group marginp">
            {newline?.map((item, index) => (
              <div key={index + 1} className="mb-2 activationtype_form">
                <div className="row">
                  <div className="col d-flex p-5px">
                    <input
                      type="text"
                      value={item.imei}
                      onChange={(e) => handleimeichange(e, index)}
                      className="form-control imeinameinput"
                      placeholder={
                        index === 0 ? `IMEI #` : `IMEI #${index + 1}`
                      }
                      style={{ position: "relative" }}
                    />
                    <OverlayTrigger
                      // placement="right"
                      delay={{ show: 100, hide: 250 }}
                      overlay={renderTooltip}
                    >
                      <img
                        alt="where to find IMEI"
                        src="./what_img.png"
                        width={15}
                        height={15}
                        style={{ marginTop: "8px", marginLeft: "5px" }}
                      />
                    </OverlayTrigger>
                  </div>
                  <div className="col p-5px">
                    <div className="d-flex">
                      <input
                        type="text"
                        value={item.device_name}
                        onChange={(e) => handledevicenamechange(e, index)}
                        className={"form-control"}
                        placeholder={`Device Name ${index + 1}`}
                      />
                      {newline.length > 1 && !item.category ? (
                        <p
                          className="crossdevice"
                          onClick={() => canceldevice(index)}
                        >
                          x
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {item.category && (
                    <div className="col p-5px">
                      <div className="d-flex">
                        {item.category === "gps" ? (
                          <>
                            <PlanModal
                              plan={item.plantype}
                              handledeviceplanchange={handledeviceplanchange}
                              index={index}
                              servicePlanGPS={servicePlanGPS}
                              servicerules={servicerules}
                            />
                            {/* <select
                              value={item.servicePlan}
                              onChange={(e) => handledeviceplanchange(e, index)}
                              className={
                                newline.length > 1
                                  ? "form-control inputcross"
                                  : "form-control"
                              }
                            >
                              <option value="">SELECT PLAN</option>
                              {servicePlanGPS?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.service_plan_id}
                                >
                                  {item.service_plan_name}
                                </option>
                              ))}
                            </select> */}
                          </>
                        ) : (
                          <>
                            <PlanModalOBD
                              plan={item.plantypeobd}
                              handledeviceplanchange={handledeviceplanchange}
                              index={index}
                              servicePlanGPS={servicePlan}
                              servicerules={servicerules}
                            />
                            {/* <select
                            value={item.servicePlan}
                            onChange={(e) =>
                              handledeviceplanchange(e, index, "obd")
                            }
                            className={
                              newline.length > 1
                                ? "form-control inputcross"
                                : "form-control"
                            }
                          >
                            <option value="">SELECT PLAN</option>
                            {servicePlan?.map((item) => (
                              <option
                                key={item.id}
                                value={item.service_plan_id}
                              >
                                {item.service_plan_name}
                              </option>
                            ))}
                          </select> */}
                          </>
                        )}
                        {newline.length > 1 ? (
                          <p
                            className="crossdevice"
                            onClick={() => canceldevice(index)}
                          >
                            x
                          </p>
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
                {item.error && (
                  <>
                    {item.errormessage ===
                      "IMEI already in use, please try with another IMEI" &&
                    queryparam?.["customer_id"] ? (
                      <span className="errormessage">
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                        IMEI already in use, please try with another IMEI or
                        {"  "}
                        <span
                          className="activation_reactivate"
                          onClick={movetoreactivate}
                        >
                          {" "}
                          Reactivate.
                        </span>
                      </span>
                    ) : (
                      <span className="errormessage">
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                        {item.errormessage}
                      </span>
                    )}
                  </>
                )}
              </div>
            ))}
            {newline.length < 4 ? (
              <p
                className="newlinecss"
                onClick={() => {
                  setnewline((prev) => [
                    ...prev,
                    {
                      imei: "",
                      device_name: "",
                      device_model: "",
                      error: false,
                      errormessage: "",
                      category: "",
                      servicePlan: "",
                      price: "",
                      plan_name: "",
                      plantype: "plus_quarterly",
                      plantypeobd: "plus_obd_quarterly",
                    },
                  ]);
                }}
              >
                + Add More Devices
              </p>
            ) : null}
            {imeisameerror && (
              <span className="errormessage">
                <i className="fa fa-times errorifont" aria-hidden="true"></i>
                IMEI should be different
              </span>
            )}
          </div>
          {/* <div className="form-group">
            <div className="row">
              <div className="col-md-12">
                <label style={{ display: "flex" }}>Service Plan </label>
                <select
                  {...register("servicePlan", { required: true })}
                  value={stateCust?.servicePlan}
                  onChange={inputEvent}
                  className={"form-control"}
                >
                  <option value="">SELECT PLAN</option>
                  {servicePlan?.map((item) => (
                    <option key={item.id} value={item.service_plan_id}>
                      {item.service_plan_name}
                    </option>
                  ))}
                </select>
                {errors.servicePlan && (
                  <span className="errormessage">
                    <span>
                      <i
                        className="fa fa-times errorifont"
                        aria-hidden="true"
                      ></i>
                    </span>
                    Service Plan is required
                  </span>
                )}
              </div>
            </div>
          </div> */}
          <div className="form-group">
            <div className="row">
              <div className="col-md-12">
                <select
                  {...register("unit", { required: true })}
                  value={stateCust?.unit}
                  onChange={inputEvent}
                  className="form-control"
                >
                  <option value="">Unit of Measurement</option>
                  <option value="KMH">KMH</option>
                  <option value="MPH">MPH</option>
                </select>
                {errors.unit && (
                  <span className="errormessage">
                    <span>
                      <i
                        className="fa fa-times errorifont"
                        aria-hidden="true"
                      ></i>
                    </span>
                    Unit is required
                  </span>
                )}
              </div>
            </div>
          </div>
          <div
            className="activation"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <button
              className="btn "
              style={{ backgroundColor: "#ccc", borderColor: "#ccc" }}
              onClick={handlepreviousbutton}
            >
              Previous
            </button>
            <button className={"btn btn-primary"} type="submit">
              Next
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ActivationTypeForm;
